import { getGrantedEntitlementsFromSubscriptions, isSubscriptionOnHold } from "@/lib/billing/entitlements";
import { getCanonicalSubscriptionSlugForPriceId } from "@/utils/stripe/subscription-slugs";
import type { SubscriptionData } from "@/types/subscriptions";

export const DIAMOND_UPGRADE_LABEL = "Upgrade to Diamond Plan";

type MemberSubscription = Pick<SubscriptionData, "price_id" | "status" | "period_end"> & Partial<Pick<SubscriptionData, "held_until" | "hold_started_at">>;

function liveSubscriptions(subscriptions: readonly MemberSubscription[], now: number): MemberSubscription[] {
  return subscriptions.filter(
    (subscription) =>
      (subscription.status === "active" || subscription.status === "trialing") &&
      new Date(subscription.period_end).getTime() > now &&
      !isSubscriptionOnHold(subscription, new Date(now)),
  );
}

export function isDiamondMember(subscriptions: readonly MemberSubscription[], now: number = Date.now()): boolean {
  return liveSubscriptions(subscriptions, now).some(
    (subscription) => getCanonicalSubscriptionSlugForPriceId(subscription.price_id) === "diamond",
  );
}

export function diamondUpgradeHref(subscriptions: readonly MemberSubscription[], now: number = Date.now()): string | null {
  const live = liveSubscriptions(subscriptions, now);
  if (live.length === 0 || isDiamondMember(live, now)) return null;
  const tools = getGrantedEntitlementsFromSubscriptions(live, new Date(now));
  const missing = !tools.has("ev-sniper") ? "ev-sniper" : !tools.has("whale-watch") ? "whale-watch" : null;
  return missing ? `/pricing?product_type=${missing}` : "/pricing";
}
